import { createStore } from "./createStore";
import type { AdminSnapshot } from "../types";

export const adminStore = createStore<AdminSnapshot>({
  authorized: false,
  packs: [],
  auditEvents: [],
});
